import { useEffect, useState } from 'react';

import InputField from '../../Forms/Input/InputField';
import Checkbox from '../../Forms/Input/Checkbox';
import FormModal from '../../Modals/FormModal';
import ButtonCustom from '../../../pages/UiElements/ButtonCustom';

interface Props {
  open: boolean;
  channel: any;
  onClose: () => void;
  onSave: (data: any) => void;
}

interface FormValues {
  code: string;
  name: string;
  description: string;
  enabled: boolean;
}

const initialForm: FormValues = {
  code: '',
  name: '',
  description: '',
  enabled: true,
};

const RealtimeChannelModal = ({ open, channel, onClose, onSave }: Props) => {
  const [form, setForm] = useState<FormValues>(initialForm);

  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (channel) {
      setForm({
        code: channel.code ?? '',
        name: channel.name ?? '',
        description: channel.description ?? '',
        enabled: channel.enabled ?? true,
      });

      return;
    }

    setForm(initialForm);
  }, [channel]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    const newErrors: Record<string, string> = {};

    if (!form.code.trim()) {
      newErrors.code = 'Código requerido';
    }

    if (!form.name.trim()) {
      newErrors.name = 'Nombre requerido';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onSave(form);
  };

  return (
    <FormModal
      isOpen={open}
      onClose={onClose}
      title={channel ? 'Editar Canal Realtime' : 'Nuevo Canal Realtime'}
      maxWidth="max-w-2xl"
    >
      <div className="space-y-5">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            label="Código"
            name="code"
            iconKey="tag"
            value={form.code}
            onChange={handleChange}
            error={errors.code}
            required
            disabled={!!channel}
            type="text"
          />

          <InputField
            label="Nombre"
            name="name"
            iconKey="category"
            value={form.name}
            onChange={handleChange}
            error={errors.name}
            type="text"
            required
          />
        </div>

        <InputField
          label="Descripción"
          name="description"
          type="text"
          iconKey="edit"
          value={form.description}
          onChange={handleChange}
        />

        <div
          className="
            rounded-sm
            border
            border-stroke
            p-4

            dark:border-strokedark
          "
        >
          <Checkbox
            label="Canal activo"
            checked={form.enabled}
            onChange={() =>
              setForm((prev) => ({
                ...prev,
                enabled: !prev.enabled,
              }))
            }
          />
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <ButtonCustom
            text="Cancelar"
            variant="danger"
            iconKey="cancel"
            onClick={onClose}
          />

          <ButtonCustom
            text="Guardar"
            variant="primary"
            iconKey="save"
            onClick={handleSave}
          />
        </div>
      </div>
    </FormModal>
  );
};

export default RealtimeChannelModal;
